/**
 * Hour arithmetic helpers.
 *
 * Hours are planned, stored and shown to a tenth of an hour. Adding tenths in
 * binary floating point does not stay on that grid (57.8 + 57.8 + 57.8 is
 * 173.40000000000003), so every hour total that is accumulated from parts must
 * be put back on it — otherwise the drift reaches the UI and the bookings.
 */

/** Rounds hours to a tenth of an hour. */
export function roundHours(hours: number): number {
  return Math.round(hours * 10) / 10;
}

/** Sum of hour values, rounded to a tenth of an hour. */
export function sumHours(values: number[]): number {
  return roundHours(values.reduce((sum, h) => sum + h, 0));
}
